import OrchCustomData from '../helpers/orch-custom-data';

const setSrcWindowReference = windowReference => {
  if (windowReference) {
    OrchCustomData.setSrcReference({ windowReference });
  }
};

export default setSrcWindowReference;
